/**
 * Parses a GeoJSON geometry string and returns a Polygon.
 * - Polygon → returned as-is.
 * - MultiPolygon → first ring is returned as a Polygon.
 * - Otherwise → empty Polygon.
 */
export function geometryGeoJsonToPolygon(geometryGeoJson: string): GeoJSON.Polygon {
  try {
    const parsed = JSON.parse(geometryGeoJson) as GeoJSON.Geometry;

    if (parsed.type === "Polygon") {
      return parsed;
    }

    if (parsed.type === "MultiPolygon" && parsed.coordinates[0]) {
      return { type: "Polygon", coordinates: parsed.coordinates[0] };
    }

    return { type: "Polygon", coordinates: [] };
  } catch {
    return { type: "Polygon", coordinates: [] };
  }
}
